<template>
  <a-card hoverable @click="$emit('click', region)" style="cursor:pointer">
    <template #title>
      <a-space>
        <a-badge :color="region.remaining > 0 ? 'green' : 'gray'" />
        <span>{{ region.region_name }}</span>
      </a-space>
    </template>
    <template #extra>
      <a-tag :color="lineColor">{{ lineName }}</a-tag>
    </template>
    <div style="font-size:12px;color:#6b7280">{{ ipCount }} 节点已开</div>
    <div style="margin-top:4px" :style="{ color: region.remaining === 0 ? '#faad14' : '#1f2937' }">
      剩余 {{ region.remaining }} / {{ region.capacity }}{{ region.remaining === 0 ? ' ⚠' : '' }}
    </div>
  </a-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps<{ region: any }>();
defineEmits<{ (e: 'click', region: any): void }>();

const lineName = computed(() => {
  if (props.region.region_name.startsWith('网通')) return '网通';
  if (props.region.region_name.startsWith('电信')) return '电信';
  return '双线';
});
const lineColor = computed(() => ({
  '网通': 'blue', '电信': 'red', '双线': 'purple',
}[lineName.value] as string));
const ipCount = computed(() => props.region.node_ids?.length || 0);
</script>
